import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import { device } from '../utils/breakpoints';

const ShowcaseWrapper = styled.section`
  background: linear-gradient(135deg, #0F2744 0%, #1A3A5C 100%);
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 80% 20%, rgba(255, 215, 0, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 20% 80%, rgba(124, 179, 66, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
  
  @media ${device.tablet} {
    padding: 60px 0;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
`;

const SectionTitle = styled.h2`
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
  text-align: center;
  
  @media ${device.tablet} {
    font-size: 32px;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  max-width: 700px;
  margin: 0 auto 32px;
  text-align: center;
  
  @media ${device.tablet} {
    font-size: 16px;
    margin-bottom: 24px;
  }
`;

const CTAContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const PrimaryButton = styled(Link)`
  background: linear-gradient(135deg, #FFD700 0%, #FF6B35 100%);
  color: #0F2744;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 215, 0, 0.5);
    background: linear-gradient(135deg, #FFE84D 0%, #FF8652 100%);
    color: #0F2744;
    text-decoration: none;
  }
`;

const StatsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-top: 48px;
  flex-wrap: wrap;
  
  @media ${device.tablet} {
    gap: 32px;
    margin-top: 32px;
  }
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #FFD700 0%, #FF6B35 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
  
  @media ${device.tablet} {
    font-size: 28px;
  }
`;

const StatLabel = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

const SolutionsShowcase = () => {
  return (
    <ShowcaseWrapper>
      <Container>
        <Content>
          <SectionTitle>200+ Enterprise Solutions Ready to Deploy</SectionTitle>
          <SectionSubtitle>
            Browse our comprehensive catalogue of pre-configured open-source applications
            across multiple categories. Deploy in minutes, not weeks.
          </SectionSubtitle>
          
          <CTAContainer>
            <PrimaryButton to="/solutions/catalogue">
              Explore Solutions Catalogue →
            </PrimaryButton>
          </CTAContainer>
          
          <StatsContainer>
            <StatItem>
              <StatNumber>200+</StatNumber>
              <StatLabel>Solutions Available</StatLabel>
            </StatItem>
            <StatItem>
              <StatNumber>15min</StatNumber>
              <StatLabel>Average Setup Time</StatLabel>
            </StatItem>
            <StatItem>
              <StatNumber>60%</StatNumber>
              <StatLabel>Cost Savings</StatLabel>
            </StatItem>
          </StatsContainer>
        </Content>
      </Container>
    </ShowcaseWrapper>
  );
};

export default SolutionsShowcase;

